'use strict';

var React = require('react');
var TargetLine = require('./TargetLine.js');
var GoalProgressBar_styles = require('./GoalProgressBar.styles.js');
var LinearProgress = require('../../../../node_modules/@material-ui/core/esm/LinearProgress/LinearProgress.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var GoalProgressBar = function GoalProgressBar(_ref) {
  var targetLineProps = _ref.targetLineProps,
      _ref$primaryBarProps = _ref.primaryBarProps,
      primaryBarProps = _ref$primaryBarProps === void 0 ? {
    value: 0
  } : _ref$primaryBarProps,
      _ref$secondaryBarProp = _ref.secondaryBarProps,
      secondaryBarProps = _ref$secondaryBarProp === void 0 ? {
    value: 0
  } : _ref$secondaryBarProp;
  var classes = GoalProgressBar_styles.useStyles({
    primaryBarColor: primaryBarProps === null || primaryBarProps === void 0 ? void 0 : primaryBarProps.color,
    secondaryBarColor: secondaryBarProps === null || secondaryBarProps === void 0 ? void 0 : secondaryBarProps.color
  });
  return React__default["default"].createElement("div", {
    className: classes.container
  }, React__default["default"].createElement(LinearProgress["default"], {
    "aria-label": "Primary bar is showing ".concat(primaryBarProps.value, "% and secondary bar is showing ").concat(secondaryBarProps.value, "%"),
    className: classes.linearProgress,
    variant: "buffer",
    value: primaryBarProps.value,
    valueBuffer: secondaryBarProps.value,
    classes: {
      dashed: classes.grayBar,
      bar2Buffer: classes.secondaryBar,
      bar1Buffer: classes.primaryBar
    }
  }), targetLineProps && React__default["default"].createElement(TargetLine, {
    label: targetLineProps.label,
    value: targetLineProps.value
  }));
};

module.exports = GoalProgressBar;
